module.exports = __webpack_public_path__ + "static/media/appstore.4186d344.svg";